import {
  resolveDynamicFlag,
  useDynamicFlag,
} from "@/utils/featureFlagOverride";

const GENERATIONS_FLAG_KEY = "VITE_FF_ENABLE_GENERATIONS";
const generationsEnvValue =
  import.meta.env.VITE_FF_ENABLE_GENERATIONS === "true";

export const isGenerationsEnabled = () =>
  generationsEnvValue &&
  resolveDynamicFlag(GENERATIONS_FLAG_KEY, generationsEnvValue);

export const useIsGenerationsEnabled = () => {
  const overrideValue = useDynamicFlag(
    GENERATIONS_FLAG_KEY,
    generationsEnvValue,
  );
  return generationsEnvValue && overrideValue;
};
